<template>
  <ModalWindow :show-modal="visible" @close="$emit('close')">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary align-items-center">
          <h5 class="modal-title">
            <span>
              <slot name="title"> </slot>
            </span>
          </h5>

          <slot name="title-end"></slot>
          <Popper :content="$t('crud.close')" placement="left" arrow hover>
            <a
              href="#"
              @click="$emit('close')"
              data-dismiss="modal"
              :aria-label="$t('crud.close')"
              class="btn btn-primary pb-1 pl-2 pr-2"
            >
              <i class="fa fa-square-xmark text-lg" style="font-size: 1.3rem !important"></i>
            </a>
          </Popper>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer border-top-0">
          <template v-if="$slots.submit && !$slots.footer">
            <slot name="submit"></slot>
            <button type="button" class="btn btn-secondary fs-4" @click="$emit('close')">
              {{ $t('crud.close') }}
            </button>
          </template>
          <slot v-else name="footer"> </slot>
        </div>
      </div>
    </div>
  </ModalWindow>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ModalWindow from '@components/modals/ModalWindow.vue'

export default defineComponent({
  name: 'ModalComponent',
  components: { ModalWindow },
  props: {
    visible: Boolean
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
</script>
